// @ts-nocheck
(function () {
  // Each Shopify section injects the same <script> tag, so this IIFE runs once
  // per section on the page. The guard below ensures setup only happens once.
  if (window.__reviewsTransformationsLoaded) return;
  window.__reviewsTransformationsLoaded = true;

  var MOBILE_BP = 749;
  var INITIAL_SLIDERS = 4;

  var mergedItems = []; // [{ slide, originalWrapper }]
  var hiddenSections = []; // sections hidden by mobile merge

  function isMobile() {
    return window.innerWidth <= MOBILE_BP;
  }

  // ── Mobile: merge all sliders into the first one ──────────────────────────
  function mergeSlidersForMobile() {
    var allSliders = Array.from(document.querySelectorAll(".reviews-transformations-slider.swiper"));
    if (allSliders.length < 2) return;

    var hostWrapper = allSliders[0].querySelector(".swiper-wrapper");

    allSliders.forEach(function (slider, i) {
      if (i === 0) return;
      var wrapper = slider.querySelector(".swiper-wrapper");
      Array.from(wrapper.children).forEach(function (slide) {
        mergedItems.push({ slide: slide, originalWrapper: wrapper });
        hostWrapper.appendChild(slide);
      });
      var section = slider.closest(".shopify-section");
      if (section) {
        section.setAttribute("data-reviews-merged", "true");
        hiddenSections.push(section);
      }
    });
  }

  function restoreSlidersFromMobile() {
    mergedItems.forEach(function (item) {
      item.originalWrapper.appendChild(item.slide);
    });
    mergedItems = [];
    hiddenSections.forEach(function (section) {
      section.removeAttribute("data-reviews-merged");
    });
    hiddenSections = [];
  }

  // ── Desktop load-more: uses DOM attributes so re-runs are idempotent ──────
  function resetExtraSections() {
    document.querySelectorAll(".shopify-section[data-reviews-extra-hidden]").forEach(function (section) {
      section.style.display = "";
      section.removeAttribute("data-reviews-extra-hidden");
    });
    document.querySelectorAll(".reviews-transformations-load-more-wrapper").forEach(function (el) {
      el.remove();
    });
  }

  function hideExtraSections() {
    var allSliders = Array.from(document.querySelectorAll(".reviews-transformations-slider"));
    if (allSliders.length <= INITIAL_SLIDERS) return;

    var anchorSection = allSliders[INITIAL_SLIDERS - 1].closest(".shopify-section");

    // Hide every section from the 5th slider onwards
    allSliders.forEach(function (slider, i) {
      if (i < INITIAL_SLIDERS) return;
      var section = slider.closest(".shopify-section");
      if (section && !section.hasAttribute("data-reviews-extra-hidden")) {
        section.style.display = "none";
        section.setAttribute("data-reviews-extra-hidden", "true");
      }
    });

    // Only add the button if there are actually hidden sections
    if (!anchorSection || !document.querySelector("[data-reviews-extra-hidden]")) return;

    var wrapper = document.createElement("div");
    wrapper.className = "reviews-transformations-load-more-wrapper";

    var btn = document.createElement("button");
    btn.className = "reviews-transformations-btn-load label-m";
    btn.type = "button";
    btn.textContent = "LOAD MORE";
    wrapper.appendChild(btn);
    anchorSection.after(wrapper);

    btn.addEventListener("click", function () {
      document.querySelectorAll("[data-reviews-extra-hidden]").forEach(function (section, i) {
        section.style.display = "";
        section.removeAttribute("data-reviews-extra-hidden");
        section.classList.remove("reviews-section-reveal");
        void section.offsetWidth;
        section.style.animationDelay = (i * 0.08) + "s";
        section.classList.add("reviews-section-reveal");
        section.addEventListener("animationend", function () {
          section.classList.remove("reviews-section-reveal");
          section.style.animationDelay = "";
        }, { once: true });
      });
      initReviewsTransformationsSlider(document);
      wrapper.remove();
    });
  }

  // ── Swiper init ────────────────────────────────────────────────────────────
  function initReviewsTransformationsSlider(root) {
    if (typeof window.Swiper === "undefined") return;

    var scope = root || document;
    var sliders = scope.querySelectorAll(".reviews-transformations-slider.swiper");

    sliders.forEach(function (slider) {
      if (slider.swiper) return;
      // Skip sliders inside hidden ancestors (display:none)
      if (slider.offsetParent === null) return;

      // On responsive/non-mobile sizes, skip Swiper for testimonials page sections (grid layout instead)
      var sectionEl = slider.closest(".section-reviews-transformations");
      if (!isMobile() && sectionEl && sectionEl.dataset.noResponsiveSlider === "true") return;

      var slidesCount = slider.querySelectorAll(".swiper-slide").length;
      if (slidesCount <= 0) return;

      var paginationEl = slider.querySelector(".reviews-transformations-pagination");
      var section = slider.closest(".section-reviews-transformations");
      // Arrows live in a controls row that is a sibling of the slider, so query from the section.
      var prevEl = section ? section.querySelector(".reviews-transformations-button-prev") : null;
      var nextEl = section ? section.querySelector(".reviews-transformations-button-next") : null;
      var autoRotate = section ? section.dataset.autoRotate !== "false" : true;
      var autoplayDelay = section ? Math.round((parseFloat(section.dataset.autoplayDelay) || 4) * 1000) : 4000;
      var slideSpeed = section ? Math.round((parseFloat(section.dataset.slideSpeed) || 0.6) * 1000) : 600;
      var isTestimonialsPage = section && section.dataset.noResponsiveSlider === "true";
      var mobile = isMobile();
      var navigationType = section ? (section.dataset.navigationType || "dots") : "dots";
      var useArrows = navigationType === "arrows" && prevEl && nextEl;

      new window.Swiper(slider, {
        slidesPerView: "auto",
        spaceBetween: 12,
        centeredSlides: true,
        loop: true,
        speed: slideSpeed,
        autoHeight: false,
        observer: mobile,
        observeSlideChildren: mobile,
        ...(autoRotate ? {
          autoplay: {
            delay: autoplayDelay,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          },
        } : {}),
        ...(useArrows ? { navigation: { prevEl: prevEl, nextEl: nextEl } } : {}),
        ...((!useArrows && paginationEl) ? {
          pagination: { el: paginationEl, clickable: true, dynamicBullets: true, dynamicMainBullets: isTestimonialsPage ? 1 : 3 },
        } : {}),
        breakpoints: {
          // 'auto' keeps the fixed 331px card width so the next card peeks in at
          // tablet-portrait sizes (iPad Mini/Air) instead of forcing exactly 2
          // full-bleed columns with no indication that more testimonials follow.
          750: { slidesPerView: 'auto', spaceBetween: 16, centeredSlides: false },
          1024: { slidesPerView: 3, spaceBetween: 16, centeredSlides: false },
          1280: { slidesPerView: 4, spaceBetween: 16, centeredSlides: false },
          1441: { slidesPerView: 'auto', spaceBetween: 16, centeredSlides: false },
        },
      });
    });
  }

  // ── Main init ──────────────────────────────────────────────────────────────
  function init() {
    document.querySelectorAll(".reviews-transformations-slider.swiper-initialized").forEach(function (s) {
      if (s.swiper) s.swiper.destroy(true, true);
    });

    restoreSlidersFromMobile();
    resetExtraSections();

    if (isMobile()) {
      mergeSlidersForMobile();
    } else {
      hideExtraSections();
    }

    initReviewsTransformationsSlider(document);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  var resizeTimer;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(init, 250);
  });

  document.addEventListener("shopify:section:load", function () {
    init();
  });
})();
